import http from '../../../http'

const state = {
    noticeList: []
};

const mutations = {
    SET_NOTICE_LIST: (state, payload) =>{
        state.noticeList = payload.records;
    }
};

const actions = {
    getNoticeList({commit, state}) {
        http.post('/supplier-resource/system/vendor/PageInfo').then((res) => {
            if(res.data.code === '200') {
                commit('SET_MESSAGE_LIST',res.data.data);
            }
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
